import { KnownBaleChamberType } from '@internal/utils/machine/KnownBalerChamberType'
import { KnownMachineHeaderType } from '@internal/utils/machine/KnownMachineHeaderType'
import { localeNamespace } from '@internal/utils/machine/i18n/Locale'
import {
  baleChamberTranslationMapping,
  machineHeaderTypeTranslationMapping,
} from '@internal/utils/machine/i18n/translationMappings'
import { TFilterOption } from '@renderer-ui-library/molecules'
import { useTranslation } from 'next-i18next'
import { useMemo } from 'react'

export const useBaleChamberTypeOptions = () => {
  const { t } = useTranslation(localeNamespace.common)

  const baleChamberTypeOptions = useMemo<TFilterOption[]>(
    () => [
      {
        id: KnownBaleChamberType.FIXED_CHAMBER,
        label: t(
          baleChamberTranslationMapping[KnownBaleChamberType.FIXED_CHAMBER]
        ),
      },
      {
        id: KnownBaleChamberType.SEMI_VARIABLE_CHAMBER,
        label: t(
          baleChamberTranslationMapping[
            KnownBaleChamberType.SEMI_VARIABLE_CHAMBER
          ]
        ),
      },
      {
        id: KnownBaleChamberType.VARIABLE_CHAMBER,
        label: t(
          baleChamberTranslationMapping[KnownBaleChamberType.VARIABLE_CHAMBER]
        ),
      },
    ],
    [t]
  )

  const machineHeaderTypeOptions = useMemo<TFilterOption[]>(
    () => [
      {
        id: KnownMachineHeaderType.FRONT_END_EXTENSION,
        label: t(
          machineHeaderTypeTranslationMapping[
            KnownMachineHeaderType.FRONT_END_EXTENSION
          ]
        ),
      },
      {
        id: KnownMachineHeaderType.GRAIN_HEADER,
        label: t(
          machineHeaderTypeTranslationMapping[
            KnownMachineHeaderType.GRAIN_HEADER
          ]
        ),
      },
      {
        id: KnownMachineHeaderType.GRASS_SEED_HEADER,
        label: t(
          machineHeaderTypeTranslationMapping[
            KnownMachineHeaderType.GRASS_SEED_HEADER
          ]
        ),
      },
      {
        id: KnownMachineHeaderType.MAIZE_HEADER,
        label: t(
          machineHeaderTypeTranslationMapping[
            KnownMachineHeaderType.MAIZE_HEADER
          ]
        ),
      },
      {
        id: KnownMachineHeaderType.RAPESEED_HEADER,
        label: t(
          machineHeaderTypeTranslationMapping[
            KnownMachineHeaderType.RAPESEED_HEADER
          ]
        ),
      },
      {
        id: KnownMachineHeaderType.SUNFLOWER_HEADER,
        label: t(
          machineHeaderTypeTranslationMapping[
            KnownMachineHeaderType.SUNFLOWER_HEADER
          ]
        ),
      },
      {
        id: KnownMachineHeaderType.PICK_UP,
        label: t(
          machineHeaderTypeTranslationMapping[KnownMachineHeaderType.PICK_UP]
        ),
      },
      {
        id: KnownMachineHeaderType.PICKER,
        label: t(
          machineHeaderTypeTranslationMapping[KnownMachineHeaderType.PICKER]
        ),
      },
      {
        id: KnownMachineHeaderType.OTHER,
        label: t(
          machineHeaderTypeTranslationMapping[KnownMachineHeaderType.OTHER]
        ),
      },
      {
        id: KnownMachineHeaderType.GPS_CUTTING_UNIT,
        label: t(
          machineHeaderTypeTranslationMapping[
            KnownMachineHeaderType.GPS_CUTTING_UNIT
          ]
        ),
      },
      {
        id: KnownMachineHeaderType.HEADER,
        label: t(
          machineHeaderTypeTranslationMapping[KnownMachineHeaderType.HEADER]
        ),
      },
      {
        id: KnownMachineHeaderType.MAIZE_PICKER,
        label: t(
          machineHeaderTypeTranslationMapping[
            KnownMachineHeaderType.MAIZE_PICKER
          ]
        ),
      },
    ],
    [t]
  )

  return { baleChamberTypeOptions, machineHeaderTypeOptions }
}
